var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2233_48366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 12.5003C3.38945 12.5003 3.00116 12.5003 2.69488 12.3735C2.2865 12.2043 1.96204 11.8798 1.79288 11.4715C1.66602 11.1652 1.66602 10.7769 1.66602 10.0003V4.33366C1.66602 3.40024 1.66602 2.93353 1.84767 2.57701C2.00746 2.2634 2.26243 2.00844 2.57603 1.84865C2.93255 1.66699 3.39926 1.66699 4.33268 1.66699H9.99935C10.7759 1.66699 11.1642 1.66699 11.4705 1.79386C11.8789 1.96302 12.2033 2.28747 12.3725 2.69585C12.4993 3.00214 12.4993 3.39042 12.4993 4.16699M10.166 18.3337H15.666C16.5994 18.3337 17.0661 18.3337 17.4227 18.152C17.7363 17.9922 17.9912 17.7372 18.151 17.4236C18.3327 17.0671 18.3327 16.6004 18.3327 15.667V10.167C18.3327 9.23357 18.3327 8.76686 18.151 8.41034C17.9912 8.09674 17.7363 7.84177 17.4227 7.68198C17.0661 7.50033 16.5994 7.50033 15.666 7.50033H10.166C9.23259 7.50033 8.76588 7.50033 8.40936 7.68198C8.09576 7.84177 7.84079 8.09674 7.681 8.41034C7.49935 8.76686 7.49935 9.23357 7.49935 10.167V15.667C7.49935 16.6004 7.49935 17.0671 7.681 17.4236C7.84079 17.7372 8.09576 17.9922 8.40936 18.152C8.76588 18.3337 9.23259 18.3337 10.166 18.3337Z",
    stroke: "#F37721",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2233_48366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyOrange);
export default __webpack_public_path__ + "static/media/copy-orange.f7691ca46787588f10a11200ad23e910.svg";
export { ForwardRef as ReactComponent };